import RateCardStore from './rate-card-store';

export default class RateCardRootStore {
	rateCardStore: RateCardStore;

	init() {
		this.rateCardStore = new RateCardStore();
	}
}
